import { Injectable } from '@angular/core';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { BriefingTypeIdEnum } from 'src/app/domain/registration/enums/briefing-type.enum';
import { IDENTIDADE_VISUAL_FORM_CONFIG } from './identidade-visual.form';
// Importar a nova definição
import { WEBSITE_FORM_CONFIG } from './website.form';
import { REGISTER_CUSTOMERS_CONFIG } from './register-customers.form';
import { REGISTER_PARTNERS_CONFIG } from './register-partners';
// Importe outras definições de formulário aqui conforme necessário
// import { WEBSITE_FORM_CONFIG } from './website.form';

@Injectable({
  providedIn: 'root'
})
export class BriefingFormDefinitionService {

  constructor() { }

  /**
   * Retorna a configuração de campos (perguntas) para um tipo específico de briefing.
   * @param type O ID numérico do tipo de briefing (BriefingTypeIdEnum).
   * @returns Um array de IFieldConfig ou null se o tipo não for encontrado.
   */
  getFormDefinition(type: number): IFieldConfig[] | null {
    switch (type) {
      case BriefingTypeIdEnum.IDENTIDADE_VISUAL:
        return IDENTIDADE_VISUAL_FORM_CONFIG;
      case BriefingTypeIdEnum.WEBSITE:
        return WEBSITE_FORM_CONFIG;
      case BriefingTypeIdEnum.REGISTER_CUSTOMERS:
        return REGISTER_CUSTOMERS_CONFIG;
      case BriefingTypeIdEnum.REGISTER_PARTNERS:
        return REGISTER_PARTNERS_CONFIG;
      
      // case BriefingTypeIdEnum.WEBSITE:
      //   return WEBSITE_FORM_CONFIG;
      // Adicione outros cases para outros tipos de briefing
      default:
        console.warn(`Definição de formulário não encontrada para o tipo de briefing: ${type}`);
        return null; // Ou retorne um array vazio: []
    }
  }
} 